import { useState } from 'react';
import { filterClickHandler, fireFilterEvent, topicFilter } from '../common';
import { FilterList, MobileFilterSection, MobileFilterTitle } from './styled';

export default function MobileFilter(props) {
  const { mutate, setShowLoader, selectedFilter } = props;
  const [selectedIndex, setSelectedIndex] = useState(selectedFilter);

  return (
    <MobileFilterSection>
      <MobileFilterTitle>Filter By Stage</MobileFilterTitle>
      <FilterList>
        {topicFilter?.map((data, index) => {
          return (
            <li
              className={data?.key == selectedIndex ? 'selected' : null}
              onClick={() => {
                (filterClickHandler(data?.key, mutate, setShowLoader),
                  setSelectedIndex(data?.key),
                  fireFilterEvent(data?.name));
              }}
              key={`filter_${index}`}
            >
              {data?.name}
            </li>
          );
        })}
      </FilterList>
    </MobileFilterSection>
  );
}
